<template>
    <!-- v-show: Keep EditUserProfile alive component so that the checkout can call the update method via ref="tab". -->
    <EditUserProfile v-show="edit_profile" @close="close" :edit_profile="edit_profile" ref="tab" />
    <ShowUserProfile v-show="!edit_profile" @edit="edit" :checkoutAccountDataError="checkoutAccountDataError" />
</template>

<script>
export default {
    props: ['checkoutAccountDataError'],
    data: () => ({
        edit_profile: false
    }),
    methods: {
        close() {
            this.edit_profile = false;
            this.$emit('editingProfile', this.edit_profile);
        },
        edit() {
            this.edit_profile = true;
            this.$emit('editingProfile', this.edit_profile);
        }
    }
};
</script>
